import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';

interface Response {
  success: boolean;
}

export async function requestPortalMagicLinkByEmail(
  orgId: string,
  email: string,
  signal: AbortSignal
): Promise<Response> {
  return await axiosClient
    .post<Response>(`${generalEnv.nextCommonApiUrl}/portal/request-magic-link?orgId=${orgId}`, email, { signal })
    .then((response) => {
      return response.data;
    });
}
